import { RgParent } from '../core/constraints/rg-parent.js';

/** cache ancestors */
const ancestors = {};
/** Recursively get all parents that may contain `type` as their descendant */
function getAncestorTypes(type, list, alreadyDigested = []) {
    /** is top of recursion */
    const top = !list;
    let ancestorsOfType = ancestors[type];
    /** if already calculated return ancestor */
    if (top && ancestorsOfType)
        return ancestorsOfType;
    alreadyDigested.push(type);
    if (!list)
        list = new Set();
    const nextParents = RgParent[type].slice();
    for (const parentType of nextParents) {
        if (alreadyDigested.includes(parentType))
            continue;
        getAncestorTypes(parentType, list);
        list.add(parentType);
    }
    if (top)
        ancestorsOfType = ancestors[type] = Array.from(list);
    return ancestorsOfType || [];
}

export { getAncestorTypes };
//# sourceMappingURL=get-ancestor-types.js.map
